import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { AuthService } from '@core/services/auth.service'

/**
 * AuthGuard
 * - Allows navigation only if the user is authenticated
 * - Redirects unauthenticated users to the signin page with a return URL
 */
export const authGuard: CanActivateFn = (_route, state) => {
  // Resolve required services at runtime to keep this purely functional
  const authService = inject(AuthService)
  const router = inject(Router)

  // If the user is already authenticated, allow navigation

  if (authService.isAuthenticated()) {
    return true
  }

  // Otherwise, redirect to signin and preserve the intended URL for post-login redirect
  return router.createUrlTree(['/auth/signin'], { queryParams: { redirect: state.url } })
}


